export default {
  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      this.showConfirm('You have unsaved data. Do you want to abandon these changes?')
        .then(next, next);
    } else {
      next();
    }
  },
};
